module.exports = __webpack_public_path__ + "media/images/emblems/Kirchberg-coat_of_arms-fad1177e36fb1c69c1bb5076ec36b7f9.svg";